var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modal",attrs:{"title":_vm.modalTitle,"header-bg-variant":"primary","header-text-variant":"light","ok-title":_vm.okTitle},on:{"ok":_vm.ok}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }